<template>
  <mf-loading loader="products-tree" loader-type="dialog">
    <div class="tree-component">
      <v-layout class="list-container">
        <v-flex v-for="level in [0, 1, 2, 3, 4, 5, 6, 7, 8, 9]" :key="level">
          <div class="level-text">
            <span v-if="selectedPerLevel[level] !== undefined">{{ levelLabels[level] }}</span>
          </div>
          <div v-if="selectedPerLevel[level] !== undefined" class="list-column">
            <dynamic-scroller
              v-if="selectedPerLevel[level].children"
              v-slot="{ item, index, active }"
              class="vue-recycle-scroller scroller ready direction-vertical"
              :items="selectedPerLevel[level].children"
              :min-item-size="56"
            >
              <div class="item-list" :style="{ height: 50 }">
                <dynamic-scroller-item :item="item" :active="active" :data-index="index" watchData>
                  <tree-level
                    v-if="forceUpdateItens"
                    :item="item"
                    selection-mode
                    :id-on-path="getSafe(() => selectedPerLevel[level + 1].id)"
                    @selected-item="selectedItem"
                    @picked-item="pickedItem"
                  />
                </dynamic-scroller-item>
              </div>
            </dynamic-scroller>
          </div>
        </v-flex>
      </v-layout>
    </div>
  </mf-loading>
</template>

<script>
import TreeLevel from '@/components/tree/TreeLevel.vue'
import { DynamicScroller, DynamicScrollerItem } from 'vue-virtual-scroller'
import 'vue-virtual-scroller/dist/vue-virtual-scroller.css'
import isEqual from 'lodash/isEqual'
import cloneDeep from 'lodash/cloneDeep'

export default {
  components: {
    TreeLevel,
    DynamicScroller,
    DynamicScrollerItem,
  },
  props: {
    tree: Object,
    levelLabels: Array,
    selectedItems: Array,
  },
  data: () => ({
    selectedPerLevel: [],
    selectionMode: false,
    dialog: false,
    forceUpdateCounter: 0,
    forceUpdateItens: true,
    localSelectedItems: [],
  }),
  computed: {
    isDialogButtonDisabled() {
      return true
    },
  },
  mounted() {
    this.selectedPerLevel.push(this.tree)
    this.applyInitialSelected()
  },
  methods: {
    selectedItem(item) {
      if (item.children?.length) {
        this.selectedPerLevel = this.selectedPerLevel.slice(0, item.level).concat(item)
        this.$nextTick(() => {
          let container = document.querySelector('.list-container')
          container.scrollLeft = container.scrollWidth
        })
      } else {
        this.selectedPerLevel = this.selectedPerLevel.slice(0, item.level)
      }
    },
    pickAllChildren(parent, args = {}) {
      const branch = (args.branch || []).concat([parent.id])
      if (!parent.children?.length) {
        if (args.addToSelectedItems) {
          if (parent.picked) {
            this.addBranchToPicked(branch)
          } else {
            this.removeBranchToPicked(branch)
          }
        }
        return
      }
      parent.children.forEach((eachItem) => {
        eachItem.picked = parent.picked
        eachItem.indeterminate = parent.indeterminate
        this.pickAllChildren(eachItem, { ...args, branch })
      })
    },
    addBranchToPicked(branch) {
      if (!this.localSelectedItems.some((item) => isEqual(item, branch))) {
        this.localSelectedItems.push(branch)
      }
      this.$emit('update:selectedItems', this.localSelectedItems)
    },
    removeBranchToPicked(branch) {
      this.localSelectedItems = this.localSelectedItems.filter((item) => !isEqual(item, branch))
      this.$emit('update:selectedItems', this.localSelectedItems)
    },

    pickedItem(item, value) {
      if (item.picked) item.indeterminate = false
      const currentBranch = this.selectedPerLevel.slice(1, item.level).map((item) => item.id)
      this.forceUpdateItens = false
      this.selectedItem(item)
      this.updateParentPickedStatus(item)
      this.pickAllChildren(item, { addToSelectedItems: true, branch: currentBranch })
      this.$nextTick(() => {
        this.forceUpdateItens = true
      })
    },
    updateParentPickedStatus(item) {
      if (!item.level) return

      for (let parentLevel = item.level - 1; parentLevel >= 1; parentLevel--) {
        const parentObject = this.selectedPerLevel[parentLevel]
        if (parentObject) {
          this.applyObjectCheckboxAccordingToChildren(parentObject)
        }
      }
    },

    applyObjectCheckboxAccordingToChildren(item) {
      let indeterminateChildren = item.children.filter((obj) => obj.indeterminate).length
      let pickedChildren = item.children.filter((obj) => obj.picked).length

      let childrenLength = item.children.length
      if (indeterminateChildren >= 1) {
        this.setCheckboxToIndeterminate(item)
      } else if (pickedChildren === 0) {
        this.setCheckboxToFalse(item)
      } else if (childrenLength === pickedChildren) {
        this.setCheckboxToTrue(item)
      } else {
        this.setCheckboxToIndeterminate(item)
      }
    },

    setCheckboxToFalse(object) {
      object.picked = false
      object.indeterminate = false
    },
    setCheckboxToIndeterminate(object) {
      object.picked = false
      object.indeterminate = true
    },
    setCheckboxToTrue(object) {
      object.picked = true
      object.indeterminate = false
    },
    isItemOnPath(selected, item) {
      if (!selected || !item) return false
      return Boolean(selected.id === item.id)
    },

    applyInitialSelected() {
      this.localSelectedItems = cloneDeep(this.selectedItems)

      this.localSelectedItems.forEach((selectedItem) => {
        let node = this.selectedPerLevel[0]
        const branch = []
        selectedItem.forEach((selectedItemIdLevel) => {
          branch.unshift(node)
          node = node.children.find((child) => child.id === selectedItemIdLevel)
        })
        node.picked = true
        branch.forEach(this.applyObjectCheckboxAccordingToChildren)
        this.pickAllChildren(node)
      })
      this.$nextTick(() => {
        this.forceUpdateItens = true
      })
    },
  },
}
</script>
<style lang="scss">
.tree-component {
  height: calc(100vh - 350px);
  .list-container {
    scroll-behavior: smooth;
    overflow-x: auto;
    border-radius: 0;
    height: 100%;
    > .flex {
      width: 250px;
      max-width: 250px;
    }
    .level-text {
      padding: 8px;
      color: $cinza-d10;
      font-size: 18px;
    }
    .list-column {
      width: 250px;
      overflow-y: auto;
      height: 90%;
    }
  }
  .scroller {
    height: 100%;
  }

  .item-list {
    display: flex;
    height: 45%;
  }

  .select-mode-content {
    margin: 0 0 8px 8px;

    span {
      margin: 11px 8px 0 0;
    }
  }
}
</style>
